/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {
  CheckoutRequest,
  CheckoutSessionResponse,
  CreditBalanceResponse,
  CreditHistoryResponse,
  CreditPackagesResponse,
  GetMyHistoryParams,
  InvoiceUrlResponse,
  RedeemPromoCodeRequest,
  RedeemPromoCodeResponse,
} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Returns the public credit package catalogue (prices, credits, savings) and credit-system constants.
 */
export type getPackagesResponse200 = {
  data: CreditPackagesResponse
  status: 200
}

export type getPackagesResponseSuccess = getPackagesResponse200 & {
  headers: Headers
}
export type getPackagesResponse = getPackagesResponseSuccess

export const getGetPackagesUrl = () => {
  return `/credits/packages`
}

export const getPackages = async (options?: RequestInit): Promise<getPackagesResponse> => {
  return customFetch<getPackagesResponse>(getGetPackagesUrl(), {
    ...options,
    method: 'GET',
  })
}

/**
 * Returns the current user's credit balance
 */
export type getMyBalanceResponse200 = {
  data: CreditBalanceResponse
  status: 200
}

export type getMyBalanceResponseSuccess = getMyBalanceResponse200 & {
  headers: Headers
}
export type getMyBalanceResponse = getMyBalanceResponseSuccess

export const getGetMyBalanceUrl = () => {
  return `/credits/me`
}

export const getMyBalance = async (options?: RequestInit): Promise<getMyBalanceResponse> => {
  return customFetch<getMyBalanceResponse>(getGetMyBalanceUrl(), {
    ...options,
    method: 'GET',
  })
}

/**
 * Returns paginated credit history for the current user
 */
export type getMyHistoryResponse200 = {
  data: CreditHistoryResponse
  status: 200
}

export type getMyHistoryResponseSuccess = getMyHistoryResponse200 & {
  headers: Headers
}
export type getMyHistoryResponse = getMyHistoryResponseSuccess

export const getGetMyHistoryUrl = (params?: GetMyHistoryParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : String(v)))
      } else {
        normalizedParams.append(key, value === null ? 'null' : value.toString())
      }
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/credits/me/history?${stringifiedParams}` : `/credits/me/history`
}

export const getMyHistory = async (
  params?: GetMyHistoryParams,
  options?: RequestInit,
): Promise<getMyHistoryResponse> => {
  return customFetch<getMyHistoryResponse>(getGetMyHistoryUrl(params), {
    ...options,
    method: 'GET',
  })
}

/**
 * Returns the customer-facing receipt URL for a PURCHASE ledger entry.

Lemon Squeezy doesn't issue invoices automatically. The receipt URL lands
on the customer's "My Orders" page on Lemon Squeezy where they can fill in
billing details and download a PDF invoice.

Order of resolution: prefer the URL captured from the `order_created`
webhook. If missing (legacy row), fetch from `GET /v1/orders/{id}` and
backfill the column so the next call is free.

404 if the row doesn't exist or isn't a PURCHASE; 403 if owned by someone else.
 */
export type getInvoiceResponse200 = {
  data: InvoiceUrlResponse
  status: 200
}

export type getInvoiceResponseSuccess = getInvoiceResponse200 & {
  headers: Headers
}
export type getInvoiceResponse = getInvoiceResponseSuccess

export const getGetInvoiceUrl = (ledgerId: string) => {
  return `/credits/invoice/${ledgerId}`
}

export const getInvoice = async (ledgerId: string, options?: RequestInit): Promise<getInvoiceResponse> => {
  return customFetch<getInvoiceResponse>(getGetInvoiceUrl(ledgerId), {
    ...options,
    method: 'GET',
  })
}

/**
 * Creates a Lemon Squeezy checkout session for purchasing credits.

Requires `consentVersion` — the key of the consent statement the user ticked
in the checkout modal. The BE refuses to mint a checkout URL for any version
not in `PURCHASE_CONSENT_TEXTS`; this guarantees we can always reproduce the
exact text the buyer saw when persisting it on the resulting CreditBatch.
 */
export type createCheckoutResponse200 = {
  data: CheckoutSessionResponse
  status: 200
}

export type createCheckoutResponseSuccess = createCheckoutResponse200 & {
  headers: Headers
}
export type createCheckoutResponse = createCheckoutResponseSuccess

export const getCreateCheckoutUrl = () => {
  return `/credits/checkout`
}

export const createCheckout = async (
  checkoutRequest: CheckoutRequest,
  options?: RequestInit,
): Promise<createCheckoutResponse> => {
  return customFetch<createCheckoutResponse>(getCreateCheckoutUrl(), {
    ...options,
    method: 'POST',
    headers: {'Content-Type': 'application/json', ...options?.headers},
    body: JSON.stringify(checkoutRequest),
  })
}

/**
 * Redeems a promo code and grants its credits to the current user.

400 if the code is unknown/blank; 409 if this user already redeemed it
(one redemption per user, enforced by the credit ledger). Codes are
case-insensitive (normalised to uppercase server-side).
 */
export type redeemPromoResponse200 = {
  data: RedeemPromoCodeResponse
  status: 200
}

export type redeemPromoResponseSuccess = redeemPromoResponse200 & {
  headers: Headers
}
export type redeemPromoResponse = redeemPromoResponseSuccess

export const getRedeemPromoUrl = () => {
  return `/credits/redeem`
}

export const redeemPromo = async (
  redeemPromoCodeRequest: RedeemPromoCodeRequest,
  options?: RequestInit,
): Promise<redeemPromoResponse> => {
  return customFetch<redeemPromoResponse>(getRedeemPromoUrl(), {
    ...options,
    method: 'POST',
    headers: {'Content-Type': 'application/json', ...options?.headers},
    body: JSON.stringify(redeemPromoCodeRequest),
  })
}
